{
  "language": {
    "name": "Português",
    "title": "Idioma"
  },
  "format": {
    "currency": "{{value, currency(currency: USD)}}",
    "number": "{{value, number(maximumFractionDigits: 9)}}"
  },
  "button": {
    "auto": "Automático",
    "bridge": "Ponte",
    "buy": "Comprar",
    "buyNow": "Comprar agora",
    "cancel": "Cancelar",
    "connectWallet": "Conectar carteira",
    "contactSupport": "Falar com o suporte",
    "continue": "Continuar",
    "copyAddress": "Copiar endereço",
    "dark": "Escuro",
    "delete": "Apagar",
    "disconnect": "Desconectar",
    "done": "Concluído",
    "exchange": "Conversão",
    "getGas": "Obter gás",
    "hide": "Ocultar",
    "learnMore": "Saiba mais",
    "lifiCheckout": "Finalizar Compra LI.FI",
    "lifiExchange": "Conversão LI.FI",
    "light": "Claro",
    "max": "máximo",
    "ok": "Tudo certo",
    "removeTransaction": "Remover transação",
    "reset": "Redefinir",
    "resetSettings": "Redefinir as configurações",
    "reviewBridge": "Revisar ponte",
    "reviewPurchase": "Revisar compra",
    "reviewSwap": "Rever conversão",
    "seeDetails": "Ver detalhes",
    "showAll": "Mostrar tudo",
    "startBridging": "Iniciar ponte",
    "startSwapping": "Iniciar conversão",
    "swap": "Conversão",
    "tryAgain": "Tente novamente",
    "viewCoverage": "Ver cobertura",
    "viewOnExplorer": "Ver no explorador"
  },
  "header": {
    "activeTransactions": "Transações ativas",
    "bridge": "Ponte",
    "checkout": "Finalizar",
    "exchange": "Conversão",
    "from": "Converter a partir de",
    "gas": "Gás",
    "payWith": "Pagar com",
    "purchase": "Compra",
    "purchaseDetails": "Detalhes da compra",
    "selectChain": "Selecionar uma rede",
    "selectWallet": "Selecionar sua carteira",
    "settings": "Configurações",
    "swap": "Conversão",
    "to": "Converter para",
    "transactionDetails": "Detalhes da transação",
    "transactionHistory": "Histórico de transações",
    "walletConnected": "Carteira conectada",
    "youGet": "Você recebe"
  },
  "info": {
    "message": {
      "autoRefuel": "Você está com pouco gás na rede {{chainName}}. Ao continuar, você obterá gás suficiente para completar a conversão.",
      "emptyActiveTransactions": "As transações em andamento aparecerão aqui. Uma vez concluídas, encontre-as no histórico de transações.",
      "emptyTokenList": "Não conseguimos encontrar tokens na rede {{chainName}} ou você não possui nenhum. Por favor, procure pelo endereço de contrato caso o token não apareça ou escolha outra rede.",
      "emptyTransactionHistory": "O histórico de transações é armazenado apenas localmente e será excluído se você limpar os dados do seu navegador.",
      "routeNotFound": "Razões para isso podem ser: baixa liquidez, valor selecionado é muito baixo, os custos com gás são muito elevados ou não há rotas para a combinação selecionada."
    },
    "title": {
      "autoRefuel": "Obter gás",
      "emptyActiveTransactions": "Nenhuma transação ativa",
      "emptyTransactionHistory": "Nenhuma transação recente",
      "routeNotFound": "Nenhuma rota disponível"
    }
  },
  "success": {
    "message": {
      "exchangePartiallySuccessful": "Tentamos completar a transação, mas {{tool}} ficou sem liquidez com o token {{tokenSymbol}}.",
      "exchangeSuccessful": "Agora há {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} na carteira {{walletAddress}} na rede {{chainName}}.",
      "purchaseSuccessful": "Agora você tem {{assetName}} na carteira {{walletAddress}} na cadeia {{chainName}}"
    },
    "title": {
      "bridgePartiallySuccessful": "Ponte parcialmente concluída",
      "bridgeSuccessful": "Ponte bem sucedida",
      "purchaseSuccessful": "Compra efetuada com sucesso",
      "refundIssued": "Reembolso emitido",
      "swapPartiallySuccessful": "Conversão parcialmente bem sucedida",
      "swapSuccessful": "Conversão bem sucedida"
    }
  },
  "warning": {
    "message": {
      "deleteActiveTransactions": "Transações ativas são armazenadas apenas localmente e não podem ser recuperadas se você excluí-las.",
      "deleteTransactionHistory": "O histórico de conversões é armazenado apenas localmente e não pode ser recuperado caso seja excluído.",
      "highValueLoss": "A quantidade de tokens a serem recebidos é significativamente menor do que os tokens convertidos e os custos da transação.",
      "insufficientFunds": "Você não possui fundos suficientes para completar a conversão.",
      "insufficientGas": "Você não tem gás suficiente para completar a conversão. É necessário adicionar pelo menos:",
      "rateChanged": "A taxa de câmbio mudou. Ao continuar a conversão, você aceitará a nova taxa.",
      "resetSettings": "Isto redefinirá sua prioridade de rota, tolerância a derrapagem, preço de gás, pontes e trocas ativadas."
    },
    "title": {
      "deleteActiveTransactions": "Excluir todas as transações ativas?",
      "deleteTransaction": "Excluir esta transação?",
      "deleteTransactionHistory": "Excluir histórico de transação?",
      "highValueLoss": "Alta perda de valor",
      "insufficientGas": "Gás insuficiente",
      "rateChanged": "Taxa alterada",
      "resetSettings": "Redefinir as configurações?"
    }
  },
  "error": {
    "message": {
      "allowanceRequired": "A quantidade a ser transferida para {{tokenSymbol}} excede a sua permissão atual. Por favor, aumente a sua permissão e tente novamente.",
      "insufficientFunds": "Você não tem gás suficiente para cobrir o custo da transação.",
      "slippageThreshold": "A derrapagem é maior do que o limite definido. Solicite uma nova rota para obter uma nova cotação.",
      "transactionFailed": "Por favor, verifique o explorador de blocos para mais informações.",
      "transactionNotSent": "A transação não foi enviada. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} na {{chainName}} permanece na sua carteira.",
      "transactionRejected": "Sua assinatura é necessária para completar a transação. {{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} em {{chainName}} permanece na sua carteira.",
      "unknown": "Por favor, tente novamente ou fale com o suporte."
    },
    "title": {
      "allowanceRequired": "Permissão insuficiente",
      "balanceIsTooLow": "O saldo é muito baixo",
      "chainSwitch": "Necessário mudança de rede",
      "gasLimitIsTooLow": "O limite de gás é muito baixo",
      "insufficientFunds": "Saldo insuficiente",
      "slippageNotMet": "Condições de tolerância a discrepâncias não foram atendidas",
      "transactionCanceled": "Transação cancelada",
      "transactionFailed": "Transação falhou",
      "transactionRejected": "Necessário assinatura",
      "transactionUnderpriced": "Transação está abaixo do valor",
      "transactionUnprepared": "Não foi possível preparar a transação",
      "unknown": "Algo deu errado",
      "walletAddressInvalid": "Endereço da carteira é inválido.",
      "walletAddressRequired": "Endereço da carteira é necessário.",
      "walletEnsAddressInvalid": "O endereço da carteira é inválido ou a rede não suporta ENS."
    }
  },
  "tooltip": {
    "additionalProviderFee": "Pontes adicionais, DEXes e taxas de serviço.",
    "estimatedNetworkFee": "Taxa de rede estimada.",
    "estimatedTime": "Tempo de execução da conversão estimado em minutos.",
    "notFound": {
      "text": "Não conseguimos encontrar esta página.",
      "title": "404"
    },
    "numberOfSteps": "Um número de passos para a conversão. Cada etapa pode conter 1-2 transações que requerem uma assinatura.",
    "progressToNextUpdate": "Os dados exibidos serão atualizados automaticamente após {{value}} segundos. Clique aqui para atualizar manualmente.",
    "recommended": "Uma rota econômica que equilibra complexidade e facilidade de uso.",
    "settingsModified": "Configurações (modificado)"
  },
  "main": {
    "crossStepDetails": "Ponte de {{from}} para {{to}} via {{tool}}",
    "currentAmount": "Quantidade atual",
    "estimatedTime": "{{value}}min",
    "featuredTokens": "Tokens em destaque",
    "from": "De",
    "fromAmount": "Você paga",
    "gasCost": "Custo do gás",
    "gasFeeEstimated": "Taxa de gás estimada",
    "gasFeePaid": "taxa de gás paga",
    "inProgress": "em andamento",
    "nftStepDetails": "Comprar NFT via {{tool}}",
    "onChain": "em {{chainName}}",
    "otherTokens": "Outros tokens",
    "ownedBy": "Possuído por",
    "process": {
      "crossChain": {
        "actionRequired": "Por favor, assine a transação",
        "done": "Transação da ponte confirmada",
        "pending": "Aguardando a transação da ponte",
        "started": "Preparando a transação da ponte"
      },
      "nft": {
        "done": "NFT comprado"
      },
      "receivingChain": {
        "done": "Ponte concluída",
        "partial": "Ponte parcialmente concluída",
        "pending": "Aguardando a rede de destino",
        "refunded": "Transação de ponte reembolsada"
      },
      "swap": {
        "actionRequired": "Por favor, assine a transação",
        "done": "Conversão concluída",
        "pending": "Aguardando a transação de conversão",
        "started": "Preparando a transação de conversão"
      },
      "switchChain": {
        "actionRequired": "Necessário mudança de rede",
        "done": "Rede alterada com sucesso"
      },
      "tokenAllowance": {
        "done": "Permissão de token aprovada",
        "pending": "Aguardando a permissão do token",
        "started": "Configurando a permissão do token"
      }
    },
    "quotedAmount": "Valor da cotação",
    "rateChange": "Alterar taxa",
    "receiving": "Recebendo",
    "refuelStepDetails": "Obter gás via {{tool}}",
    "selectChain": "Selecione a rede",
    "selectChainAndToken": "Selecione a rede e o token",
    "selectToken": "Selecione o Token",
    "sendToAddress": "Enviar para",
    "sendToWallet": "Enviar para uma carteira diferente",
    "sending": "Enviando",
    "sentToAddress": "Enviar para",
    "stepBridge": "Ponte",
    "stepBridgeAndBuy": "Transfira e compre",
    "stepDetails": "{{tool}} via LI.FI",
    "stepSwap": "Conversão",
    "stepSwapAndBridge": "Converter e enviar pela ponte",
    "stepSwapAndBuy": "Converta e compre",
    "supportId": "ID de suporte",
    "swapStepDetails": "Converter na {{chain}} via {{tool}}",
    "tags": {
      "cheapest": "Barato",
      "fastest": "Rápido",
      "insurable": "Assegurável",
      "insurance": "Seguro",
      "insured": "Segurado",
      "recommended": "Recomendado",
      "safest": "Seguro"
    },
    "to": "Para",
    "tokenOnChain": "{{tokenSymbol}} na {{chainName}}",
    "tokenOnChainAmount": "{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}} na {{chainName}}",
    "tokenSearch": "Pesquisar pelo nome do token ou endereço",
    "valueLoss": "Perda de Valor",
    "walletAddressOrEns": "Endereço da carteira ou nome ENS"
  },
  "insurance": {
    "bridgeExploits": "Mau funcionamento da ponte, hacks ou exploits",
    "insure": "Contratar seguro para <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> em trânsito.",
    "insured": "Você contratou seguro para <0>{{amount, number(maximumFractionDigits: 9)}} {{tokenSymbol}}</0> em trânsito:",
    "slippageError": "Erro na discrepância para tokens recebidos"
  },
  "settings": {
    "enabledBridges": "Pontes habilitadas",
    "enabledExchanges": "Corretoras habilitadas",
    "gasPrice": {
      "fast": "Rápido",
      "normal": "Normal",
      "slow": "Lento",
      "title": "Preço do gás"
    },
    "routePriority": "Prioridade de rota / caminho",
    "showDestinationWallet": "Mostrar carteira de destino",
    "slippage": "Derrapagem",
    "resetSettings": "Você está usando a configuração personalizada que limita a quantidade de rotas disponíveis."
  },
  "wallet": {
    "extensionNotFound": "Por favor, certifique-se de que apenas a extensão do navegador da {{name}} está ativa antes de escolher esta carteira."
  }
}
